function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { DateInput, DateRangeInput } from "@blueprintjs/datetime";
import { camelCase } from "lodash";
import classNames from "classnames";
import React from "react";
import { Menu, Intent, MenuDivider, InputGroup, Classes, NumericInput } from "@blueprintjs/core";
import dayjs from "dayjs";
import getDayjsFormatter from "../utils/getDayjsFormatter";
import { onEnterHelper } from "../utils/handlerHelpers";
import DialogFooter from "../DialogFooter";
import "@teselagen/react-table/react-table.css";
import "./style.css";
import "../toastr";

var isInvalidFilterValue = function isInvalidFilterValue(value) {
  if (Array.isArray(value)) {
    return value.some(function (item) {
      return isInvalidFilterValue(item);
    });
  }

  return value === "" || value === undefined;
};

var FilterAndSortMenu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FilterAndSortMenu, _React$Component);

  function FilterAndSortMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleFilterChange", function (selectedFilter) {
      _this.setState({
        selectedFilter: camelCase(selectedFilter)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilterValueChange", function (filterValue) {
      _this.setState({
        filterValue: filterValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilterSubmit", function () {
      var _this$state = _this.state,
          filterValue = _this$state.filterValue,
          selectedFilter = _this$state.selectedFilter;
      var togglePopover = _this.props.togglePopover;
      var ccSelectedFilter = camelCase(selectedFilter);
      var filterValToUse = filterValue;

      if (ccSelectedFilter === "true" || ccSelectedFilter === "false") {
        //manually set the filterValue because none is set when type=boolean
        filterValToUse = ccSelectedFilter;
      } else if (ccSelectedFilter === "notEmpty") {
        // manually set filter value (nothing is selected by user)
        filterValToUse = true;
      }

      var _this$props = _this.props,
          filterOn = _this$props.filterOn,
          addFilters = _this$props.addFilters,
          removeSingleFilter = _this$props.removeSingleFilter;

      if (isInvalidFilterValue(filterValToUse)) {
        return removeSingleFilter(filterOn);
      }

      addFilters([{
        filterOn: filterOn,
        selectedFilter: ccSelectedFilter,
        filterValue: filterValToUse
      }]);
      togglePopover();
    });

    var _selectedFilter = camelCase(getFilterMenuItems(props.dataType)[0]);

    _this.state = _extends({
      selectedFilter: _selectedFilter,
      filterValue: ""
    }, _this.props.currentFilter);
    return _this;
  }

  var _proto = FilterAndSortMenu.prototype;

  // handleSubmit(event) {
  //   alert('A name was submitted: ' + this.state.value);
  //   event.preventDefault();
  // }
  _proto.render = function render() {
    var _this$state2 = this.state,
        selectedFilter = _this$state2.selectedFilter,
        filterValue = _this$state2.filterValue;
    var _this$props2 = this.props,
        dataType = _this$props2.dataType,
        currentFilter = _this$props2.currentFilter,
        removeSingleFilter = _this$props2.removeSingleFilter;
    var handleFilterChange = this.handleFilterChange,
        handleFilterValueChange = this.handleFilterValueChange,
        handleFilterSubmit = this.handleFilterSubmit;
    var filterTypesDictionary = {
      none: "",
      startsWith: "text",
      endsWith: "text",
      contains: "text",
      isExactly: "text",
      notEmpty: "text",
      inList: "text",
      "true": "boolean",
      "false": "boolean",
      dateIs: "date",
      isBetween: "dateRange",
      isBefore: "date",
      isAfter: "date",
      greaterThan: "number",
      lessThan: "number",
      inRange: "numberRange",
      equalTo: "number"
    };
    var filterMenuItems = getFilterMenuItems(dataType);
    var ccSelectedFilter = camelCase(selectedFilter);
    var requiresValue = ccSelectedFilter && ccSelectedFilter !== "none";
    return /*#__PURE__*/React.createElement(Menu, {
      className: "data-table-header-menu"
    }, /*#__PURE__*/React.createElement("div", {
      className: "custom-menu-item"
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(Classes.SELECT, Classes.FILL)
    }, /*#__PURE__*/React.createElement("select", {
      onChange: function onChange(e) {
        var ccSelectedFilter = camelCase(e.target.value);
        handleFilterChange(ccSelectedFilter);
      },
      value: ccSelectedFilter
    }, filterMenuItems.map(function (menuItem, index) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        value: camelCase(menuItem)
      }, menuItem);
    })))), /*#__PURE__*/React.createElement("div", {
      className: "custom-menu-item"
    }, /*#__PURE__*/React.createElement(FilterInput, {
      dataType: dataType,
      requiresValue: requiresValue,
      handleFilterSubmit: handleFilterSubmit,
      filterValue: filterValue,
      handleFilterValueChange: handleFilterValueChange,
      filterSubType: camelCase(selectedFilter),
      filterType: filterTypesDictionary[camelCase(selectedFilter)]
    })), /*#__PURE__*/React.createElement(MenuDivider, null), /*#__PURE__*/React.createElement(DialogFooter, {
      secondaryClassName: Classes.POPOVER_DISMISS,
      onClick: function onClick() {
        handleFilterSubmit();
      },
      intent: Intent.SUCCESS,
      text: "Filter",
      secondaryText: "Clear",
      secondaryAction: function secondaryAction() {
        currentFilter && removeSingleFilter(currentFilter.filterOn);
      }
    }));
  };

  return FilterAndSortMenu;
}(React.Component);

export { FilterAndSortMenu as default };
var dateMinMaxHelpers = {
  minDate: dayjs().subtract(25, "years").toDate(),
  maxDate: dayjs().add(25, "years").toDate()
};

var FilterInput = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(FilterInput, _React$Component2);

  function FilterInput() {
    return _React$Component2.apply(this, arguments) || this;
  }

  var _proto2 = FilterInput.prototype;

  _proto2.render = function render() {
    var _this$props3 = this.props,
        handleFilterValueChange = _this$props3.handleFilterValueChange,
        handleFilterSubmit = _this$props3.handleFilterSubmit,
        filterValue = _this$props3.filterValue,
        filterSubType = _this$props3.filterSubType,
        filterType = _this$props3.filterType; //Options: Text, Single number (before, after, equals), 2 numbers (range),
    //Single Date (before, after, on), 2 dates (range)

    var inputGroup = /*#__PURE__*/React.createElement("div", null);

    switch (filterType) {
      case "text":
        inputGroup = filterSubType === "notEmpty" ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement("div", {
          className: "custom-menu-item"
        }, /*#__PURE__*/React.createElement(InputGroup, _extends({
          placeholder: "Value",
          onChange: function onChange(e) {
            handleFilterValueChange(e.target.value);
          },
          autoFocus: true
        }, onEnterHelper(handleFilterSubmit), {
          value: filterValue
        })));
        break;

      case "number":
        inputGroup = /*#__PURE__*/React.createElement("div", {
          className: "custom-menu-item"
        }, /*#__PURE__*/React.createElement(NumericInput, _extends({
          placeholder: "Value",
          onValueChange: function onValueChange(numVal) {
            handleFilterValueChange(isNaN(numVal) ? 0 : numVal);
          },
          autoFocus: true
        }, onEnterHelper(handleFilterSubmit), {
          value: filterValue
        })));
        break;

      case "numberRange":
        inputGroup = /*#__PURE__*/React.createElement("div", {
          className: "custom-menu-item"
        }, /*#__PURE__*/React.createElement(NumericInput, _extends({
          placeholder: "Low",
          onValueChange: function onValueChange(numVal) {
            handleFilterValueChange([isNaN(numVal) ? 0 : numVal, filterValue[1]]);
          }
        }, onEnterHelper(handleFilterSubmit), {
          value: filterValue && filterValue[0]
        })), /*#__PURE__*/React.createElement(NumericInput, _extends({
          placeholder: "High",
          onValueChange: function onValueChange(numVal) {
            handleFilterValueChange([filterValue[0], isNaN(numVal) ? 0 : numVal]);
          }
        }, onEnterHelper(handleFilterSubmit), {
          value: filterValue && filterValue[1]
        })));
        break;

      case "date":
        inputGroup = /*#__PURE__*/React.createElement("div", {
          className: "custom-menu-item"
        }, /*#__PURE__*/React.createElement(DateInput, _extends({
          value: filterValue ? dayjs(filterValue).toDate() : undefined
        }, getDayjsFormatter("L"), dateMinMaxHelpers, {
          onChange: function onChange(selectedDates) {
            handleFilterValueChange(selectedDates);
          }
        })));
        break;

      case "dateRange":
        var filterValueToUse;

        if (Array.isArray(filterValue)) {
          filterValueToUse = filterValue;
        } else {
          filterValueToUse = filterValue && filterValue.split && filterValue.split(".");
        }

        inputGroup = /*#__PURE__*/React.createElement("div", {
          className: "custom-menu-item"
        }, /*#__PURE__*/React.createElement(DateRangeInput, _extends({
          value: filterValueToUse && filterValueToUse[0] && filterValueToUse[1] ? [new Date(filterValueToUse[0]), new Date(filterValueToUse[1])] : undefined,
          popoverProps: {
            captureDismiss: true
          },
          formatDate: function formatDate(date) {
            return date == null ? "" : date.toLocaleDateString();
          },
          parseDate: function parseDate(str) {
            return new Date(Date.parse(str));
          },
          placeholder: "JS Date"
        }, dateMinMaxHelpers, {
          onChange: function onChange(selectedDates) {
            if (selectedDates[0] && selectedDates[1]) {
              handleFilterValueChange(selectedDates);
            }
          }
        })));
        break;

      default: // to do

    }

    return inputGroup;
  };

  return FilterInput;
}(React.Component);

function getFilterMenuItems(dataType) {
  var filterMenuItems = [];

  if (dataType === "string") {
    filterMenuItems = ["Contains", "Starts with", "Ends with", "Is exactly", "In List", "Not empty"];
  } else if (dataType === "lookup") {
    filterMenuItems = ["Contains", "Starts with", "Ends with", "Is exactly"];
  } else if (dataType === "boolean") {
    filterMenuItems = ["True", "False"];
  } else if (dataType === "number" || dataType === "integer") {
    // else if (dataType === "lookup") {
    //   filterMenuItems = ["None"];
    // }
    filterMenuItems = ["Greater than", "Less than", "In range", "Equal to", "In List"];
  } else if (dataType === "timestamp") {
    filterMenuItems = ["Is between", "Is before", "Is after"];
  }

  return filterMenuItems;
}